import { Ability } from './Ability'

/**
 * Vue plugin that provides $ability and $can to all components.
 * Replaces @casl/vue with custom implementation.
 */
export const abilitiesPlugin = {
  install(Vue) {
    // Create a shared ability instance
    const ability = new Ability()

    // Add $ability to all components
    Object.defineProperty(Vue.prototype, '$ability', {
      get() {
        return ability
      }
    })

    // Add $can shorthand method
    Object.defineProperty(Vue.prototype, '$can', {
      get() {
        return (action, subject) => ability.can(action, subject)
      }
    })
  }
}
